import {
  PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME,
  SHARING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME,
} from '@modules/feedback/components/AudioType/AudioTranscript/constants';
import { removeFeedbackMessageHighlight } from '@modules/feedback/components/AudioType/utils';

export const highlightPlayingAudioTranscriptMessage = (msgIndex: number) => {
  requestAnimationFrame(() => {
    removeFeedbackMessageHighlight(PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME);
    removeFeedbackMessageHighlight(SHARING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME);

    const messageToHighlight = document.querySelector(
      `#expanded-feedback-container [data-audio-message-id="${msgIndex.toString()}"]`,
    );

    messageToHighlight?.classList.add(
      PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME,
    );
  });
};
